import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { SORT } from './../../constants';
import SortIndicators from './../SortIndicators/SortIndicators.index';
import LightSpinnerWrapper from './../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper';

export default class LightTable extends Component {
    static propTypes = {
        pageSize: PropTypes.number,
        headerItems: PropTypes.array,
        listItems: PropTypes.array,
        noEntries: PropTypes.func,
        className: PropTypes.string,
        headerWidth: PropTypes.number
    };

    static defaultProps = {
        pageSize: 0,
        headerItems: null,
        listItems: null,
        className: "",
        noEntries: () => (
            <div className="no-entries">
                <FormattedMessage id="Entities_Edit_UIText_editThirdParty.noResults" />
            </div>
        ),
        headerWidth: null
    };

    static selectRow(item) {
        if (typeof item.onClick === "function") {
            item.onClick(item.id);
        }
    }

    renderHeaderItems(headerItems) {
        return headerItems.map(item =>
            <span className="cell" key={item.key}>
                { item.sorting ? (
                    item.sorting.direction === "asc" ? (
                        <span className="sortable" onClick={(e) => item.sorting.func({ sortBy: item.key, direction: SORT.DESC }, headerItems)}>
                            {item.label}
                            <SortIndicators direction={item.sorting.direction} />
                        </span>
                    ) : (
                        item.sorting.direction === "desc" ? (
                            <span className="sortable" onClick={(e) => item.sorting.func({ sortBy: item.key, direction: SORT.DEFAULT }, headerItems)}>
                                {item.label}
                                <SortIndicators direction={item.sorting.direction} />
                            </span>
                        ) : (
                            <span className="sortable" onClick={(e) => item.sorting.func({ sortBy: item.key, direction: SORT.ASC }, headerItems)}>
                                {item.label}
                                <SortIndicators direction={item.sorting.direction} />
                            </span>
                        )
                    )
                ) : (
                    <span>
                        {item.label}
                    </span>
                )}
            </span>)
    }


    render() {
        const headers = this.renderHeaderItems(this.props.headerItems);
        if (this.props.listItems && this.props.listItems.length === 0) {
            return (<div className="light-table">{this.props.noEntries()}</div>)
        } else {
            const rows = this.props.listItems && this.props.listItems.map((item, index) => {
                let cells = []
                this.props.headerItems.forEach(headerItem => {
                    if (headerItem.key !== "key") {
                        cells.push(item[headerItem.key]);
                    }
                })
                const cellsJsx = cells.map((cell, key) =>
                    key != "key" ? <span className="cell" key={"cell_" + index + "_" + key}>{cell}</span> : null);

                return (
                    <div className="row" key={"row_" + index}>{cellsJsx}</div>
                );
            })

            return (
                <div className={"light-table " + this.props.className}>
                    <div className="light-table__headers"
                         style={ this.props.headerWidth ? {width: this.props.headerWidth + 'px'} : null}>
                        {headers}
                     </div>
                    <div className="light-table__headers__placeholder"></div>
                    <LightSpinnerWrapper isLoading={this.props.listItems === null} />
                    <div className="light-table__rows">{rows}</div>
                </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/LightTable.jsx